// Página local /medico-do-esporte-em-bauru/ no template das páginas de
// tratamento. Texto de src/content/locais/medico-do-esporte-em-bauru.md,
// distribuído nos blocos sem reescrita.
import { EtapasLocais as CardsIlustrado, CtaLocal as CtaPratico, FaqLocal as Faq, HeroLocal as Hero, MedicoLocal as Medico, PilaresLocais as Pilares } from "@/components/itv/pages/locais";
import { MarkdownInline } from "@/components/blog/Markdown";
import { AutoriaComAviso, BotaoWhatsApp, MapaConsultorio, RQES_LOCAIS, SecaoTexto, Texto } from "@/components/itv/pages/locais";

export const faqEsporteBauru = [
  {
    pergunta: "O que trata o médico do esporte?",
    resposta:
      "O médico do esporte cuida da saúde de quem pratica atividade física, do iniciante ao atleta. Ele faz a avaliação antes de começar ou intensificar o treino, investiga sintomas que aparecem no esforço, orienta nutrição, hidratação e recuperação e acompanha pessoas com doenças crônicas que querem se exercitar com segurança.",
  },
  {
    pergunta: "Quem só quer começar a treinar pode procurar o médico do esporte?",
    resposta:
      "Sim. A diretriz da SBC e da SBMEE recomenda avaliação pré-participação para quem vai praticar exercício moderado ou intenso, competindo ou não. Ela pesa ainda mais para quem passou dos 35 anos, tem doença crônica, como hipertensão ou diabetes, ou toma remédio de uso contínuo.",
  },
  {
    pergunta: "Médico do esporte ou nutricionista esportivo: qual procurar?",
    resposta:
      "Os dois trabalham bem juntos. O médico do esporte faz a avaliação clínica, pede e interpreta exames, investiga sintomas e, quando há indicação, prescreve tratamento. O nutricionista esportivo monta o plano alimentar detalhado para a rotina de treino. Se você tem sintomas, doença crônica ou dúvida sobre suplementos, comece pela avaliação médica.",
  },
  {
    pergunta: "O médico do esporte prescreve hormônio para ganhar massa muscular?",
    resposta:
      "Não. A Resolução CFM 2.333/2023 veda o uso de esteroides anabolizantes e hormônios androgênicos com finalidade estética, de ganho de massa muscular ou de melhora do desempenho esportivo, para atletas amadores ou profissionais. Reposição hormonal só é indicada quando existe deficiência comprovada e ligada ao quadro clínico.",
  },
  {
    pergunta: "O que dá para fazer por teleconsulta e o que precisa ser presencial em Bauru?",
    resposta:
      "Por vídeo é possível avaliar histórico, sintomas, hábitos, exames, nutrição e recuperação. A bioimpedância e o exame físico acontecem no consultório do Jardim Europa. Quando a queixa pede exame físico ou uma avaliação específica, indicamos a consulta presencial em Bauru. Para quem está em outra cidade, a teleconsulta atende todo o Brasil.",
  },
];

const pilares = [
  {
    icone: "/icones/search.svg",
    titulo: "O seu corpo está pronto?",
    texto: "A consulta responde se o seu corpo está pronto para o treino que você quer fazer, em qualquer idade.",
  },
  {
    icone: "/icones/flame.svg",
    titulo: "O que trava a sua evolução",
    texto: "Quando o treino fica meses sem evoluir em carga ou em composição corporal, procuramos a causa também fora da academia.",
  },
  {
    icone: "/icones/activity.svg",
    titulo: "Nutrição na mesma consulta",
    texto: "Como o Dr. Thiago também é nutrólogo (RQE 121770), a parte de nutrição e composição corporal é vista na mesma consulta.",
  },
];

const avaliacao = [
  {
    img: "/img/esporte/conduta-1.webp",
    titulo: "Histórico",
    texto: "O treino que você faz e o que pretende fazer, doenças, remédios e suplementos em uso e casos de doença cardíaca ou morte súbita na família.",
  },
  {
    img: "/img/esporte/conduta-2.webp",
    titulo: "Sintomas no esforço",
    texto: "Palpitação, desmaio, dor ou desconforto no peito, falta de ar fora do esperado e tontura, que a diretriz lista como sinais de atenção.",
  },
  {
    img: "/img/esporte/conduta-3.webp",
    titulo: "Exame físico",
    texto: "Completo, feito no consultório.",
  },
  {
    img: "/img/esporte/conduta-4.webp",
    titulo: "Composição corporal por bioimpedância",
    texto: "Já está inclusa na consulta presencial.",
  },
  {
    img: "/img/esporte/conduta-5.webp",
    titulo: "Exames conforme o caso",
    texto: "Pedidos de acordo com a idade, o histórico e o tipo de treino.",
  },
  {
    img: "/img/esporte/conduta-6.webp",
    titulo: "Começando depois dos 40",
    texto: "Uma das situações mais frequentes no consultório. Para quem passou dos 35 e quer competir, mesmo em provas amadoras, a recomendação é ter acompanhamento médico especializado e periódico.",
  },
];

const paragrafosMedico = [
  "O Dr. Thiago Viana é médico do esporte em Bauru (CRM-SP 144.585, RQE 118488) e também nutrólogo (RQE 121770): nutrição e composição corporal são vistas na mesma consulta.",
  "Formação pela UNIFESP-EPM, em 2010. Membro da Sociedade Brasileira de Medicina do Exercício e do Esporte (SBMEE).",
];

export function EsporteBauru() {
  return (
    <main className="pag-local">
      <Hero
        trilha={[
          { nome: "Home", href: "/" },
          { nome: "Consultório em Bauru", href: "/bauru/" },
          { nome: "Médico do esporte em Bauru" },
        ]}
        sobretitulo="ATENDIMENTO EM BAURU"
        linha1="Médico do esporte"
        linha2="em Bauru."
        chamada="O Dr. Thiago Viana é médico do esporte em Bauru (CRM-SP 144.585, RQE 118488). Atende quem treina, do iniciante ao atleta amador, com avaliação de saúde, composição corporal por bioimpedância, nutrição e recuperação, no consultório do Jardim Europa ou por teleconsulta."
        imagem="/img/esporte/hero.webp"
        botao="Agendar avaliação esportiva"
      />

      <Pilares
        sobretitulo="MEDICINA DO ESPORTE"
        titulo="O que faz o médico do esporte"
        chamada="A Medicina do Exercício e do Esporte é a especialidade médica que cuida da saúde de quem pratica atividade física, seja atleta profissional, esportista amador ou alguém que está começando agora. Ela orienta como começar com segurança, como dosar o treino e como cuidar de alimentação, sono e recuperação, em qualquer idade."
        itens={pilares}
      />

      <CardsIlustrado
        sobretitulo="ANTES DE TREINAR"
        titulo="Avaliação antes de começar ou intensificar o treino"
        chamada={
          <MarkdownInline texto="Quem vai treinar em intensidade moderada ou alta deve passar antes por uma avaliação médica, a chamada avaliação pré-participação ([diretriz SBC e SBMEE](https://doi.org/10.5935/abc.20190048)). A ideia é encontrar fatores de risco e sinais de problemas no coração, no pulmão, no metabolismo ou nas articulações antes que o treino aumente, e repetir a avaliação de tempos em tempos enquanto a prática continua. No consultório de Bauru, essa avaliação inclui:" />
        }
        cards={avaliacao}
      />

      <SecaoTexto areia>
        <Texto texto="Se você sente uma dor que acompanha o treino, conte na consulta. A avaliação identifica o quadro e, quando necessário, faz o encaminhamento para o cuidado indicado." />
      </SecaoTexto>

      <SecaoTexto titulo="Nutrição, suplementação e recuperação para quem treina">
        <Texto
          texto={`Quando o treino fica meses sem evoluir em carga ou em composição corporal, procuramos a causa também fora da academia. Alimentação que não acompanha o volume de treino, pouca proteína, sono curto e recuperação insuficiente aparecem com frequência nessa investigação. Por isso a consulta ajusta energia e proteína ao seu objetivo e olha o sono com a mesma atenção que o treino.

Suplemento entra quando há indicação e evidência para o seu caso e não substitui alimentação, sono e treino. A creatina é o exemplo mais estudado, e explicamos o que os estudos mostram sobre segurança no artigo [Creatina faz mal para os rins?](/blog/creatina-faz-mal-para-os-rins/). Para quem quer ganhar ou preservar músculo, o cuidado continua na página de [massa muscular e sarcopenia](/tratamentos/massa-muscular/).

O detalhamento de cada frente, do check-up ao plano de nutrição para o treino, está na página de [medicina do esporte](/tratamentos/medicina-do-esporte/).`}
        />
      </SecaoTexto>

      <SecaoTexto titulo="Treinar no calor em Bauru: hidratação e sinais de alerta" areia>
        <Texto
          texto={`Para quem corre, pedala ou treina ao ar livre em Bauru, o calor entra no planejamento. As medidas básicas são simples: comer e se hidratar bem, respeitar o descanso e fugir dos horários mais quentes do dia. Com a idade, a sede costuma aparecer mais tarde, e por isso quem passou dos 35 precisa beber água antes de sentir sede, principalmente em provas longas.

A maioria dos problemas causados pelo calor no esforço pode ser evitada, e eles podem aparecer mesmo em dias de 15 °C ([American College of Sports Medicine](https://pubmed.ncbi.nlm.nih.gov/34524191/)). Confusão, desorientação ou mudança de comportamento durante o esforço no calor são sinais de insolação por esforço, uma emergência médica: a pessoa precisa parar a atividade, ser resfriada rapidamente e receber atendimento (SAMU 192).`}
        />
      </SecaoTexto>

      <SecaoTexto titulo="Atendimento em Bauru e por teleconsulta">
        <Texto
          texto={`A consulta presencial acontece no consultório do Jardim Europa, e reúne o exame físico e a bioimpedância. Pela teleconsulta, avaliamos histórico, sintomas, hábitos, exames, nutrição e recuperação. Quando a queixa pede exame físico ou uma avaliação específica, indicamos a consulta presencial.

Se você já treina com personal ou assessoria, a orientação médica é feita em parceria com quem prescreve o seu treino, sem substituir esse trabalho. Para quem está em outra cidade, a [teleconsulta](/consulta-online/) atende todo o Brasil.`}
        />
        <MapaConsultorio />
      </SecaoTexto>

      <SecaoTexto titulo="Agende sua avaliação esportiva em Bauru" areia>
        <Texto texto="Se você quer começar a treinar com segurança, está parado na mesma carga há meses ou quer entender o que a sua composição corporal mostra, vale uma avaliação que olhe treino, alimentação, sono e exames juntos. É assim que montamos a [Avaliação 360°](/tratamentos/avaliacao-360/) dentro do Método SP, presencial em Bauru ou por teleconsulta em todo o Brasil." />
        <BotaoWhatsApp rotulo="Agendar avaliação esportiva" />
      </SecaoTexto>

      <Medico paragrafos={paragrafosMedico} rqes={RQES_LOCAIS} />
      <Faq titulo="Perguntas frequentes" itens={faqEsporteBauru} />
      <AutoriaComAviso />
      <CtaPratico linha1="Agende sua avaliação esportiva" linha2="em Bauru. Escolha o formato." />
    </main>
  );
}
